/* ==========================================================================
   Flexara theme JS
   Scope is intentionally tiny. No browser storage is used anywhere
   (per CLAUDE.md hard rule 2): carts and capture run through Shopify/Klaviyo.
   ========================================================================== */
(function () {
  'use strict';

  /* ====================== KLAVIYO CREDENTIALS ============================
     Fill these two values to take the waitlist live. Confirm the LIST ID
     with Rob first. Only the PUBLIC key belongs here (never a private key).
       KLAVIYO_PUBLIC_KEY -> your 6-char public API key / site ID
       KLAVIYO_LIST_ID    -> the waitlist list ID
     ====================================================================== */
  var KLAVIYO_PUBLIC_KEY = 'U9vQbn'; // Flexara Health public/site API key
  var KLAVIYO_LIST_ID = 'RKf3NA';    // "Flexara Waitlist" static list

  function isConfigured() {
    return (
      KLAVIYO_PUBLIC_KEY.indexOf('KLAVIYO') === -1 &&
      KLAVIYO_LIST_ID.indexOf('KLAVIYO') === -1 &&
      KLAVIYO_PUBLIC_KEY.length > 0 &&
      KLAVIYO_LIST_ID.length > 0
    );
  }

  /* Subscribe a profile to the waitlist list via Klaviyo's client API.
     Docs: POST https://a.klaviyo.com/client/subscriptions/?company_id=PUBLIC_KEY */
  function subscribeToKlaviyo(email) {
    var endpoint =
      'https://a.klaviyo.com/client/subscriptions/?company_id=' +
      encodeURIComponent(KLAVIYO_PUBLIC_KEY);

    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: { email: email }
            }
          }
        },
        relationships: {
          list: { data: { type: 'list', id: KLAVIYO_LIST_ID } }
        }
      }
    };

    return fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        revision: '2024-10-15'
      },
      body: JSON.stringify(payload)
    });
  }

  function initWaitlistForm(form) {
    var emailInput = form.querySelector('input[name="email"]');
    var submitBtn = form.querySelector('[data-waitlist-submit]');
    var submitLabel = form.querySelector('[data-submit-label]');
    var message = form.querySelector('[data-waitlist-message]');
    var defaultLabel = submitLabel ? submitLabel.textContent : 'Join';

    function setMessage(text, state) {
      if (!message) return;
      message.textContent = text || '';
      if (state) {
        message.setAttribute('data-state', state);
      } else {
        message.removeAttribute('data-state');
      }
    }

    function setLoading(loading) {
      if (!submitBtn) return;
      submitBtn.disabled = loading;
      if (submitLabel) submitLabel.textContent = loading ? 'Joining...' : defaultLabel;
    }

    function showSuccess() {
      form.classList.add('is-success');
      setMessage('', null);
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      setMessage('', null);

      var email = (emailInput && emailInput.value || '').trim();
      if (!email || !emailInput.checkValidity()) {
        setMessage('Please enter a valid email address.', 'error');
        emailInput && emailInput.focus();
        return;
      }

      // Not wired to Klaviyo yet: fail loudly in console, not silently to the user.
      if (!isConfigured()) {
        setMessage(
          'Waitlist is not connected yet. Add the Klaviyo keys to take it live.',
          'error'
        );
        console.warn(
          '[Flexara] Klaviyo is not configured. Set KLAVIYO_PUBLIC_KEY and KLAVIYO_LIST_ID in assets/theme.js.'
        );
        return;
      }

      setLoading(true);
      subscribeToKlaviyo(email)
        .then(function (response) {
          // Klaviyo returns 202 Accepted on success.
          if (response.ok || response.status === 202) {
            showSuccess();
          } else {
            return response.text().then(function (body) {
              throw new Error(body || 'Subscription failed');
            });
          }
        })
        .catch(function (error) {
          console.error('[Flexara] Klaviyo subscription error:', error);
          setMessage('Something went wrong. Please try again.', 'error');
        })
        .finally(function () {
          setLoading(false);
        });
    });
  }

  function init() {
    document.querySelectorAll('[data-waitlist-form]').forEach(initWaitlistForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
